import mapChildren from './mapChildren';
export var nthChild = function (children, index) {
    return mapChildren(children, function (child, i) {
        if (index === null || index === undefined)
            return;
        if (i !== +index)
            return;
        return child;
    });
};
export default nthChild;
